import { HttpClient } from '@angular/common/http';
import { Component, inject, signal } from '@angular/core';
import { SystemMessage, SystemMessageService } from '../../system-message/system-message-service';

@Component({
  selector: 'pcg-google-play-delete-account',
  standalone: false,
  templateUrl: './google-play-delete-account.component.html',
  styleUrl: './google-play-delete-account.component.scss',
})
export class GooglePlayDeleteAccountComponent {

    ms = inject(SystemMessageService);
    http = inject(HttpClient);

    email = signal<string>('');
    isChecked = signal<boolean>(false);

    submitRequest() {
        if (
            this.email() == null
            || this.email() == ""
        ) { 
            this.ms.setSystemMessage("Must enter an email.", "error"); 
            return;
        }
        if (!this.isChecked()) { 
            this.ms.setSystemMessage("Must check the understand statement to submit request", "error"); 
            return;
        }

        this.http.get<SystemMessage>(`api/account/RequestAccountDelete?email=${this.email()}`).subscribe((msg: SystemMessage) => {
            this.ms.setSystemMessage(msg.message!, msg.messageClass);
        })
    }
}
